import { Component, h, Event, EventEmitter, Prop, Host } from '@stencil/core';

@Component({
    tag: 'sew-ws-tip-button',
    styleUrl: 'sew-ws-tip-button.scss',
    shadow: true,
})
export class SewWsTipButton {
    @Prop({ reflect: true, mutable: true }) expanded: boolean;
    @Prop() initialAnimationDuration = 5000;
    @Prop() initialAnimation: boolean;
    @Prop() tipLabel: string;

    @Event() clickedButton: EventEmitter<'tip'>;

    componentDidLoad(): void {
        if (this.initialAnimation) {
            setTimeout(() => (this.expanded = true), 1000);
            setTimeout(() => (this.expanded = false), this.initialAnimationDuration);
        }
    }

    render() {
        return (
            <Host>
                <button onClick={() => this.clickedButton.emit('tip')}>
                    <span>{this.tipLabel}</span>
                    <sew-icon class="svg" icon="highlight" size="xl" />
                </button>
            </Host>
        );
    }
}
